const deleteNote = async (noteId, token) => {
    const bearerToken = 'Bearer ' + token
    const headers = {
        Authorization: bearerToken,
        'Content-Type': 'application/json'
    }
    const requestOptions = {
        method: 'DELETE',
        headers: headers,
    }
    const response = await fetch(process.env.REACT_APP_DOMAIN + 'note/' + noteId, requestOptions)
    const data = await response.json()
    return { response, data }
}

const getNote = async (token) => {
    const bearerToken = 'Bearer ' + token
    const headers = {
        Authorization: bearerToken
    }
    const response = await fetch(process.env.REACT_APP_DOMAIN + 'note/', { headers })
    const data = await response.json()
    return { response, data }
}

const createNote = async (noteContent, token) => {
    const bearerToken = 'Bearer ' + token
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: bearerToken },
        body: JSON.stringify({ content: noteContent })
    }
    const response = await fetch(process.env.REACT_APP_DOMAIN + 'note/', requestOptions)
    const data = await response.json()
    return { response, data }
}

const editNote = async (noteContent, token, id) => {
    const bearerToken = 'Bearer ' + token
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: bearerToken },
        body: JSON.stringify({ content: noteContent })
    }
    const response = await fetch(process.env.REACT_APP_DOMAIN + 'note/' + id, requestOptions)
    const data = await response.json()
    return { response, data }
}
const getSpecificNote = async (token, id) => {
    const bearerToken = 'Bearer ' + token
    const headers = {
        Authorization: bearerToken
    }
    const response = await fetch(process.env.REACT_APP_DOMAIN + 'note/' + id, { headers })
    const data = await response.json()
    return { response, data }
}

const helperMethods = {
    deleteNoteHelper: deleteNote,
    getNoteHelper: getNote,
    createNote: createNote,
    editNote: editNote,
    getSpecificNote
}

export default helperMethods